import {IComponentOptions} from 'angular';
import moment from 'moment';
import {OkHtmlDialogController} from '../../../core/dialog/OkHtmlDialogController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';

let template = require('./testpageView.html');
let okHtmlDialogTemplate = require('../../../core/dialog/okHtmlDialogTemplate.html');

export class TestpageViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = TestpageViewController;
    controllerAs: string = 'vm';
}

export class TestpageViewController {
    static $inject = ['MAX_LENGTH', 'DvDialog'];

    length: number;

    datepickerValue: moment.Moment;
    valueinput: number;
    schadenid: string;

    /* @ngInject */
    constructor(MAX_LENGTH: number, private dvDialog: DvDialog) {
        this.length = MAX_LENGTH;

    }

    $onInit() {
        console.log('Version: ' + this.getVersion());
        console.log('buildtime: ' + this.getBuildtimestamp());
        console.log('env: ' + this.getClientenv());

    }

    openModal(title: any, text: any): void {
        this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
            title: title,
            text: text
        }).then(() => {
            //do nothing
        });
    }

    public getVersion(): string {
        return VERSION;
    }

    public getBuildtimestamp(): string {
        return BUILDTSTAMP;
    }

    public getClientenv(): string {
        return ENV;
    }

    public sentrytest() {
        throw new Error('This is a sentry test SERF frontend');
    }

}



// WEBPACK FOOTER //
// ./src/app/testpage/component/testpageView/testpageView.ts